module.exports = {
          srcSet: "/_next/static/images/img-telephonie@2x-160-40f4a63276fc781c8d5bca203960fb47.jpg"+" 160w"+","+"/_next/static/images/img-telephonie@2x-292-d0797effa0d42fc6792b562ca96bda5d.jpg"+" 292w",
          images:[ {path: "/_next/static/images/img-telephonie@2x-160-40f4a63276fc781c8d5bca203960fb47.jpg",width: 160,height: 137},{path: "/_next/static/images/img-telephonie@2x-292-d0797effa0d42fc6792b562ca96bda5d.jpg",width: 292,height: 250}],
          src: "/_next/static/images/img-telephonie@2x-160-40f4a63276fc781c8d5bca203960fb47.jpg",
          toString:function(){return "/_next/static/images/img-telephonie@2x-160-40f4a63276fc781c8d5bca203960fb47.jpg"},
          placeholder: undefined,
          width: 160,
          height: 137
      }